import React, { useEffect, useState } from "react";
import { backend, API_URL } from "../../../config";
import "./PickList.css";
import {
  Button,
  Checkbox,
  Container,
  CssBaseline,
  FormControl,
  FormControlLabel,
  Grid,
  Input,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Chip,
} from "@mui/material";
import { Link } from "react-router-dom";

import DatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";

import { makeStyles } from "@mui/styles";
import { useTheme } from "@emotion/react";

const useStyles = makeStyles((theme) => ({
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
}));

const getStyles = (name, ordersSelected, theme) => {
  return {
    fontWeight:
      ordersSelected.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const PickList = (props) => {
  const classes = useStyles();
  const theme = useTheme();

  const cDateIni = new Date();
  const cDateEnd = new Date();
  cDateIni.setDate(cDateIni.getDate() + 1);
  cDateEnd.setDate(cDateEnd.getDate() + 1);
  cDateIni.setHours(0, 0, 0, 0);
  cDateEnd.setHours(23, 59, 59, 0);

  const [sorting, setSorting] = useState("order");
  const [filter, setFilter] = useState("");
  const [bulk, setBulk] = useState(false);
  const [dateRange, setDateRange] = useState([cDateIni, cDateEnd]);
  const [orders, setOrders] = useState([]);
  const [ordersFull, setOrdersFull] = useState([]);
  const [ordersSelected, setOrdersSelected] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [customersSelected, setCustomersSelected] = useState([]);

  const handleSortingChange = (e) => {
    const { value } = e.target;
    setSorting(value);
  };

  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilter(value);
  };

  const handleBulkChange = (e) => {
    const { checked } = e.target;
    setBulk(checked);
  };

  const handleChangeRangeDate = (e) => {
    const { name, value } = e.target;
    setDateRange((prevState) => {
      if (name === "start_date") {
        value.setHours(0, 0, 0, 0);
        prevState[0] = value;
      } else {
        value.setHours(23, 59, 59, 0);
        prevState[1] = value;
      }
      return [prevState[0], prevState[1]];
    });
  };

  const handleChangeCustomers = (e) => {
    const { value } = e.target;
    setCustomersSelected(value);
  };

  const handleChangeOrders = (e) => {
    const { value } = e.target;
    setOrdersSelected(value);
  };

  useEffect(() => {
    const getCustomers = async () => {
      await backend.get(`${API_URL}users?no_page=1`).then(({ data }) => {
        if (data.length) {
          setCustomers(data);
        }
      });
    };

    getCustomers();
  }, []);

  useEffect(() => {
    const getOrders = async () => {
      let startDate = new Date(dateRange[0]);
      let endDate = new Date(dateRange[1]);

      const startDateParam = new Date(
        startDate.getTime() - startDate.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];
      const endDateParam = new Date(
        endDate.getTime() - endDate.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];

      await backend
        .get(
          `${API_URL}orders?no_page=1&start_date=${startDateParam}&end_date=${endDateParam}`
        )
        .then(({ data }) => {
          if (data.length) {
            startDate.setHours(0, 0, 0);
            endDate.setHours(23, 59, 59);

            const ordersFiltered = data.filter((item) => {
              const orderDate = new Date(item.delivery_date);
              return orderDate >= startDate && orderDate <= endDate;
            });

            setOrdersSelected([]);
            setCustomersSelected([]);
            setOrders(ordersFiltered);
            setOrdersFull(ordersFiltered);
          }
        });
    };

    if (dateRange[0] !== null && dateRange[1] !== null) {
      getOrders();
    }
  }, [dateRange]);

  useEffect(() => {
    const applyFilter = (ordersArray) =>
      customersSelected.length
        ? ordersArray.filter((item) =>
            customersSelected.find(
              (customer) =>
                customer.id ===
                (item.customer ? item.customer.id : item.customer)
            )
          )
        : ordersArray;

    const ordersFilter = () => {
      setOrders(applyFilter(ordersFull));
      setOrdersSelected((prevState) => applyFilter(prevState));
    };

    ordersFilter();
  }, [customersSelected, ordersFull]);

  return (
    <>
      <CssBaseline />
      <Container maxWidth="lg" className="container">
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={12}>
            <Typography variant="h6" component="div">
              Agreggate Pick List Generator
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12}>
            Select a date range, customers to display the available orders which
            can be used to generate an aggregate pick list.
          </Grid>
          <Grid item xs={12} sm={3}>
            <FormControl fullWidth>
              <InputLabel shrink id="sorting-label">
                Sorting Method
              </InputLabel>
              <Select
                fullWidth
                label="Sorting Method"
                onChange={handleSortingChange}
                name="sorting"
                input={<Input />}
                value={sorting && sorting}
                MenuProps={MenuProps}
              >
                <MenuItem value="bin">Bin Location then Order #</MenuItem>
                <MenuItem value="order">Order # then Bin Location</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={3}>
            <FormControl fullWidth>
              <InputLabel shrink id="sorting-label">
                Filter Locations
              </InputLabel>
              <Select
                fullWidth
                label="Filter Locations"
                onChange={handleFilterChange}
                name="filter"
                input={<Input />}
                value={filter && filter}
                MenuProps={MenuProps}
              >
                <MenuItem value="">None</MenuItem>
                <MenuItem value="3">Friendly Foods</MenuItem>
                <MenuItem value="4">Produce Market</MenuItem>
                <MenuItem value="2">Restaurant Depot</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2}>
            <FormControlLabel
              value="start"
              control={
                <Checkbox
                  name="bulk"
                  value={bulk}
                  checked={bulk}
                  onChange={handleBulkChange}
                  color="primary"
                />
              }
              label="Bulk Pull"
              labelPlacement="end"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                disableToolbar
                variant="inline"
                format="MM/dd/yyyy"
                margin="normal"
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                value={dateRange[0]}
                renderInput={(props) => (
                  <TextField
                    {...props}
                    fullWidth
                    label="Select start date"
                    variant="standard"
                  />
                )}
                onChange={(date) =>
                  handleChangeRangeDate({
                    target: {
                      name: "start_date",
                      value: date,
                    },
                  })
                }
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                disableToolbar
                variant="inline"
                format="MM/dd/yyyy"
                margin="normal"
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                value={dateRange[1]}
                renderInput={(props) => (
                  <TextField
                    {...props}
                    fullWidth
                    label="Select end date"
                    variant="standard"
                  />
                )}
                onChange={(date) =>
                  handleChangeRangeDate({
                    target: {
                      name: "end_date",
                      value: date,
                    },
                  })
                }
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputLabel shrink id="orders">
              Customers
            </InputLabel>
            <Select
              fullWidth
              multiple
              label="Customers"
              onChange={handleChangeCustomers}
              name="customers"
              input={<Input />}
              value={customersSelected}
              renderValue={(selected) => (
                <div className={classes.chips}>
                  {selected.map((item) => (
                    <Chip
                      key={item.id + "chip"}
                      label={`${item.username}`}
                      className={classes.chip}
                    />
                  ))}
                </div>
              )}
              MenuProps={MenuProps}
              helpertext="Select the customers to display their orders."
            >
              {customers.map((option) => (
                <MenuItem
                  key={option.id}
                  value={option}
                  style={getStyles(option.id, customersSelected, theme)}
                >
                  {`${option.username}`}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputLabel shrink id="orders">
              Orders
            </InputLabel>
            <Select
              fullWidth
              multiple
              label="Orders"
              onChange={handleChangeOrders}
              name="orders"
              input={<Input />}
              value={ordersSelected}
              renderValue={(selected) => (
                <div className={classes.chips}>
                  {selected.map((item) => (
                    <Chip
                      key={item.id + "chip"}
                      label={`${
                        item.customer ? item.customer.username : "Anonymous"
                      } #${item.id}`}
                      className={classes.chip}
                    />
                  ))}
                </div>
              )}
              MenuProps={MenuProps}
              helpertext="Select the orders to include in the picklist."
            >
              {orders.map((option) => (
                <MenuItem
                  key={option.id}
                  value={option}
                  style={getStyles(option.id, ordersSelected, theme)}
                >
                  {`${
                    option.customer ? option.customer.username : "Anoymous"
                  } #${option.id}`}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={12} sm={12} textAlign={"center"}>
            {orders.length ? (
              <>
                <Link
                  to={{
                    pathname: "/orders/picklist/details",
                    search: "?from=picklist",
                    state: {
                      sortingState: sorting,
                      filterState: filter,
                      bulkState: bulk,
                      dateRangeState: dateRange,
                      ordersState: ordersSelected.length
                        ? ordersSelected
                        : orders,
                      multiple: true,
                    },
                  }}
                  style={{
                    marginRight: "10px",
                    textDecoration: "none",
                  }}
                >
                  <Button variant="contained">
                    <Typography variant="subtitle2" className="text-white">
                      Generate
                    </Typography>
                  </Button>
                </Link>
                <Link
                  to={{
                    pathname: "/scan",
                    search: "?from=picklist",
                    state: {
                      sortingState: sorting,
                      filterState: filter,
                      bulkState: bulk,
                      dateRangeState: dateRange,
                      ordersState: ordersSelected.length
                        ? ordersSelected
                        : orders,
                    },
                  }}
                  style={{ marginRight: "10px", textDecoration: "none" }}
                >
                  <Button variant="contained">
                    <Typography variant="subtitle2" className="text-white">
                      Scan
                    </Typography>
                  </Button>
                </Link>
                <Link
                  to={{
                    pathname: "/orders/picklist/validate-stock",
                    search: `?date=${
                      new Date(
                        dateRange[0].getTime() -
                          dateRange[0].getTimezoneOffset() * 60000
                      )
                        .toISOString()
                        .split("T")[0]
                    }`,
                  }}
                  style={{ marginRight: "10px", textDecoration: "none" }}
                >
                  <Button variant="contained">
                    <Typography variant="subtitle2" className="text-white">
                      Validate Stock
                    </Typography>
                  </Button>
                </Link>
              </>
            ) : (
              <>
                <Button
                  variant="contained"
                  disabled={!ordersSelected.length}
                  style={{ marginRight: "10px" }}
                >
                  <Typography variant="subtitle2" className="text-white">
                    Generate
                  </Typography>
                </Button>
                <Button
                  variant="contained"
                  disabled={!ordersSelected.length}
                  style={{ marginRight: "10px" }}
                >
                  <Typography variant="subtitle2" className="text-white">
                    Scan
                  </Typography>
                </Button>
                <Button
                  variant="contained"
                  disabled={!orders.length}
                  style={{ marginRight: "10px" }}
                >
                  <Typography variant="subtitle2" className="text-white">
                    Validate Stock
                  </Typography>
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default PickList;
